import React from "react"

interface TextTruncateProps {
  text: string
  className?: string
}

const TextTruncate: React.FC<TextTruncateProps> = ({
  text,
  className = "",
}) => {
  return (
    <div className={`table w-full table-fixed ${className}`}>
      <div className="table-cell">
        <div className="overflow-hidden text-ellipsis whitespace-nowrap">
          {text}
        </div>
      </div>
    </div>
  )
}

export default TextTruncate
